import type React from "react";

interface StarRatingProps {
  rating: number;
  onRate?: (rating: number) => void;
  showValue?: boolean;
  valueFormat?: "fraction" | "decimal";
  size?: "sm" | "md";
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  onRate,
  showValue = false,
  valueFormat = "fraction",
  size = "md",
}) => {
  const interactive = Boolean(onRate);
  const sizeClass = size === "sm" ? "text-[0.9rem]" : "text-[1.2rem]";

  return (
    <div className="flex items-center gap-0.5">
      <div className="flex gap-1 items-center">
        {[1, 2, 3, 4, 5].map((star) => {
          const filled = star <= rating;
          return (
            <span
              key={star}
              onClick={interactive ? () => onRate?.(star) : undefined}
              className={`${sizeClass} transition-colors duration-200 ${
                interactive ? "cursor-pointer" : ""
              } ${filled ? "text-primary" : "text-muted-foreground"}`}
            >
              {"\u2605"}
            </span>
          );
        })}
      </div>
      {showValue && rating > 0 && (
        <span className="ml-2 text-base font-semibold text-foreground">
          {valueFormat === "decimal" ? rating.toFixed(1) : `${rating}/5`}
        </span>
      )}
    </div>
  );
};

export default StarRating;
